import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import Img from 'gatsby-image'
import React, { useEffect, useState } from 'react'
import ProductService from '../../../services/products'
import SessionService from '../../../services/session'
import './productDetailSection.scss'
import { Link } from 'gatsby'
import Icon from '../../../components/atoms/Icon/Icon'
import QualifySectionContent from '../../organisms/qualify-section-content/qualify-section-content'
import CommentsSectionContent from '../../organisms/comments-section-content/comments-section-content'
import useHomeLinkMode from '../../../hooks/useHomeLinkMode'
import useLocaleMode from '../../../hooks/useLocaleMode'
import useBrowserMode from '../../../hooks/useBrowserMode'
import { gothic, lonchmara } from '../../../_shared/Variables.scss'
import { pushGtagEvent,pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'
import Slider from "react-slick"
import { convertText } from '../../../utils/convertFirstCharacterToUppercase'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { useStaticQuery, graphql } from 'gatsby'

const ProductDetailSection = props => {
	const [localLikes, setlocalLikes] = useState([])
	const [isFakeLiked, setisFakeLiked] = useState(false)
	const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
	const [likeValue, setlikeValue] = useState(null)
	const { homeLink } = useHomeLinkMode()
	const [itemsRateDetails, setItemsRateDetails] = useState()
	const [ratingDetail, setRatingDetail] = useState()
	const { country, locale } = useLocaleMode()
	const { isBrowser } = useBrowserMode()
	/* Comments variables */
	const [comments, setComments] = React.useState([])
	const [currentPage, setCurrentPage] = React.useState(0)
	const [isLoader, setIsLoader] = React.useState(false)
	const [commentPlus, setCommentPlus] = React.useState(true)
	const limit = 2

	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<p className='f-card-product-description f-p'>{children}</p>
			),
			[INLINES.HYPERLINK]: (node, next) => (
				<a target='_blank' rel='noopener noreferrer' href={node.data.uri} onClick={()=> {dataLayerTalla(next[0])}}>
					{next}
				</a>
			),
		},
	}

	const dataLayerTalla = (text) => {
		if (text.toLowerCase()==='conoce tu yalla'){
			pushDataLayerEvent({
				event: 'size_guide',
				action_type: 'CTA click',
				link_text: 'Conoce tu talla',
				single_item_id: props.idProduct,
				single_item_name: props.title,
			})
		}
	}

	const formatNumber = num => {
		if (num > 999999) {
			return parseInt(num / 1000000, 10).toString() + 'M'
		} else if (num > 999) {
			return parseInt(num / 1000, 10).toString() + 'K'
		} else {
			return num
		}
	}

	const isLiked = idProduct => {
		let i
		for (i = 0; i < localLikes.length; i++) {
			if (localLikes[i] === idProduct) {
				return true
			}
		}

		return false
	}

	useEffect(() => {
		handleLoadLikes()
		setlocalLikes(
			localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null
				? JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS'))
				: []
		)
	}, [])

	const removeDoubleSlash = url => {
        return url.replace(/\/\//g, "/")
    }

	const handleLoadLikes = () => {
		if (
			!(
				localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData')
			)
		) {
			ProductService.getAnomLikes()
				.then(res => {
					setlikeValue(
						res.data.filter(item => {
							if (item.idCMS === props.idProduct) {
								return item?.like
							}
							return false
						})[0]?.like
					)
				})
				.catch(e => console.log(e))
		} else {
			localStorage.removeItem('LOCAL_LIKES_PRODUCTS')

			const config = {
				headers: {
					Authorization: SessionService.getIdTokenData(),
				},
			}

			ProductService.getAuthLikes(config)
				.then(res => {
					for (let index = 0; index < res.data.length; index++) {
						// console.log(res.data[index]);

						if (res.data[index].userLike) {
							if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
								const copyLocalLikes = JSON.parse(
									localStorage.getItem('LOCAL_LIKES_PRODUCTS')
								)
								localStorage.setItem(
									'LOCAL_LIKES_PRODUCTS',
									JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS))
								)
								setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
							} else {
								localStorage.setItem(
									'LOCAL_LIKES_PRODUCTS',
									JSON.stringify([res.data[index].idCMS])
								)
								setlocalLikes([res.data[index].idCMS])
							}
						}
					}
					setlikeValue(
						res.data.filter(item => {
							if (item.idCMS === props.idProduct) {
								return item?.like
							}
							return false
						})[0]?.like
					)
				})
				.catch(e => console.log(e))
		}
	}
	const handleUnLike = () => {
		const payload = {
			type: 'PRODUCTO',
			idCMS: props.idProduct,
		}

		if (
			!(
				localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData')
			)
		) {
			ProductService.setAnomUnLikes(payload)
				.then(res => {
					if (res.status === 200) {
						const copyLocalLikes = JSON.parse(
							localStorage.getItem('LOCAL_LIKES_PRODUCTS')
						)
						localStorage.setItem(
							'LOCAL_LIKES_PRODUCTS',
							JSON.stringify(
								copyLocalLikes.filter(item => item !== props.idProduct)
							)
						)
						setlocalLikes(
							copyLocalLikes.filter(item => item !== props.idProduct)
						)
						isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
					} else {
						console.log(res)
					}
				})
				.catch(e => console.log(e))
		} else {
			const config = {
				headers: {
					Authorization: SessionService.getIdTokenData(),
				},
			}

			ProductService.setAuthUnLikes(payload, config)
				.then(res => {
					if (res.status === 200) {
						const copyLocalLikes = JSON.parse(
							localStorage.getItem('LOCAL_LIKES_PRODUCTS')
						)
						localStorage.setItem(
							'LOCAL_LIKES_PRODUCTS',
							JSON.stringify(
								copyLocalLikes.filter(item => item !== props.idProduct)
							)
						)
						setlocalLikes(
							copyLocalLikes.filter(item => item !== props.idProduct)
						)
						isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
					} else {
						console.log(res)
					}
				})
				.catch(e => console.log(e))
		}
	}

	const handleLike = () => {
		const payload = {
			type: 'PRODUCTO',
			idCMS: props.idProduct,
		}

		if (
			!(
				localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData')
			)
		) {
			ProductService.setAnomLikes(payload)
				.then(res => {
					if (res.status === 200) {
						if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
							const copyLocalLikes = JSON.parse(
								localStorage.getItem('LOCAL_LIKES_PRODUCTS')
							)
							localStorage.setItem(
								'LOCAL_LIKES_PRODUCTS',
								JSON.stringify(copyLocalLikes.concat(props.idProduct))
							)
							setlocalLikes(copyLocalLikes.concat(props.idProduct))
							isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
						} else {
							localStorage.setItem(
								'LOCAL_LIKES_PRODUCTS',
								JSON.stringify([props.idProduct])
							)
							setlocalLikes([props.idProduct])
							isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
						}
					} else {
						console.log(res)
					}
				})
				.catch(e => console.log(e))
		} else {
			const config = {
				headers: {
					Authorization: SessionService.getIdTokenData(),
				},
			}
			ProductService.setAuthLikes(payload, config)
				.then(res => {
					if (res.status === 200) {
						if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
							const copyLocalLikes = JSON.parse(
								localStorage.getItem('LOCAL_LIKES_PRODUCTS')
							)
							localStorage.setItem(
								'LOCAL_LIKES_PRODUCTS',
								JSON.stringify(copyLocalLikes.concat(props.idProduct))
							)
							setlocalLikes(copyLocalLikes.concat(props.idProduct))
							isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
						} else {
							localStorage.setItem(
								'LOCAL_LIKES_PRODUCTS',
								JSON.stringify([props.idProduct])
							)
							setlocalLikes([props.idProduct])
							isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
						}
					} else {
						console.log(res)
					}
				})
				.catch(e => console.log(e))
		}
	}

	const query = useStaticQuery(graphql`
    query REDIRECTION_COMPRAR_BUTTON {
      allContentfulTenaHome {
        nodes {
					node_locale
          retailsDeCompra {
            redireccionRetail
          }
        }
      }
    }
  `)

	const queryRedirectionButton =
	isBrowser &&
	query &&
	query.allContentfulTenaHome.nodes.filter(
		node => node.node_locale === locale
		)[0]

	const redirectionToTenaShop = () => {
		const tenaShopUrl = "https://tienda.tena.com.co/?utm_source=tena&utm_medium=boton-compra&utm_campaign=tienda-tena" 
		const redirectionUrl = props.product?.product?.redireccionComprarEnLinea
		window.location.href = redirectionUrl && redirectionUrl.startsWith("https://tienda.tena.com.co/") ? 
			redirectionUrl
		:	queryRedirectionButton.retailsDeCompra[0]
				.redireccionRetail
				? queryRedirectionButton.retailsDeCompra[0].redireccionRetail
				: tenaShopUrl
	}

	const handleClickShowModal = () => {
		const productCategory =
			props.slug === "mujeres"
				? "Mujer"
				: props.slug === "hombres"
				? "Hombre"
				: "Unisex"
		try {
			window.dataLayer.push({
				Category: "Ecommerce",
				Action: "Add to cart",
				"Dimension 5": "Quiero comprar",
				"Product Name": props.title,
				"Product Id": props.title,
				"Product Brand": "TENA",
				"Product Category": productCategory,
				"Product Variant":
					props.nivelIncontinencia.json.content[0].content[1].value,
			})
		} catch (e) {
			console.log("dataLayer Error", e)
		}
		props.setModalVisibility(true)
    
	}

	const handleTagManager = () => {
		const productCategory =
			props.slug === 'mujeres'
				? 'Mujer'
				: props.slug === 'hombres'
				? 'Hombre'
				: 'Unisex'
		try {
			window.dataLayer.push({
				Category: 'Ecommerce',
				Action: 'Add to cart',
				'Dimension 5': 'Muestra gratis',
				'Product Name': props.title,
				'Product Id': props.title,
				'Product Brand': 'TENA',
				'Product Category': productCategory,
				'Product Variant':
					props.nivelIncontinencia.json.content[0].content[1].value,
			})
		} catch (e) {
			console.log('dataLayer Error', e)
		}
	}
	const userInfo=dataLayerUserInfo()
	const dataLaterSamples = () => {		
		let location=''
		if (typeof window !== 'undefined') {
			location= window.location.href
		}
		pushDataLayerEvent({event: 'Interacciones - Productos',
		category: 'productos',
		action: 'click',
		label:' Muestra Gratis',
		location: location, 
		user_data: userInfo.user_data? userInfo.user_data: '',
		log_status: userInfo.log_status,})
	}
	const dataLayerQuieroComprar = (productName) => {      
		let location=''
		if (typeof window !== 'undefined') {
				location= window.location.href
		}
		pushDataLayerEvent({event: 'Interacciones - Productos',
		category: 'productos',
		action: 'click',
		label: 'Quiero comprar',
		location: location,
		item_name: productName,
		user_data: userInfo.user_data? userInfo.user_data: '',
		log_status: userInfo.log_status,})
	}
	const dataLayerCalificarProducto = (productName) => {      
		let location=''
		if (typeof window !== 'undefined') {
				location= window.location.href
		}
		pushDataLayerEvent({event: 'Interacciones - Calificar Producto',
		category: 'calificar_producto',
		action: 'click',
		label: 'Calificar productos',
		location: location,
		item_name: productName,
		user_data: userInfo.user_data? userInfo.user_data: '',
		log_status: userInfo.log_status,})

		pushDataLayerEvent({
			event: 'review',
			action_type: 'Calificar producto',
			single_item_id: props.idProduct,
  			single_item_name: productName
		})
	}

	const retailsDataLayer = () => {
		pushDataLayerEvent({
			event: "buy_now_list_retailers",
  			single_item_id: props.product.product?.codigoDeProducto,
  			single_item_name: props.title,
		})
	}

	const handleRenderButtons = () => (
		<div className='f-buttons-header'>
			{props.buttonsRetails &&
				props.buttonsRetails.map((value, index) => {
					if (value) {
						if (value.shop) {
							if (
								props.haveRetails !== false &&
								props.paramRetails &&
								props.paramRetails.length >= 1
							) {
								return (
									<button
										key={index}
										className={`f-buttons-header-button-${index} `}
										onClick={() => {
											if(value.title==='QUIERO COMPRAR'){
												dataLayerQuieroComprar(props.title)
												retailsDataLayer()
											}
											if(value.title==='MUESTRA GRATIS'){
												dataLaterSamples()
											}
											if (
                        value.title === "QUIERO COMPRAR" &&
                        process.env.LOCALE === "es-CO"
                      ) {
                        redirectionToTenaShop()
                      } else {
                        handleClickShowModal()
                      }
										}}
									>
										{convertText(value.title)}
										<div className='f-img-container'>
											{value.icon && (
												<img
													className='f-shop-logo'
													src={value.icon}
													alt={value.icon.description}
												/>
											)}
										</div>
									</button>
								)
							} else {
								return null
							}
						} else {
							return (
								<Link
									key={index}
									className={`f-buttons-header-button-${index}`}
									to={value.slug}
									onClickCapture={()=>{
										dataLaterSamples()
										handleTagManager()
									}}
								>
									{convertText(value.title)}
									<div className='f-img-container'>
										{value.icon && (
											// <Img fluid={value.icon} className="f-shop-logo"
											// alt={value.icon.description}  />
											<img
												className='f-shop-logo'
												src={value.icon}
												alt={value.icon.description}
											/>
										)}
									</div>
								</Link>
							)
						}
					}
					return <></>
				})}
			{!props.isFreeSamples ? (
				<button
					className='f-buttons-header-button-3'
					onClick={() => {
						dataLayerCalificarProducto(props.title)
						window.location.href =
						homeLink + removeDoubleSlash(  'productos/' + props.url + '/calificar/')
					}}
				>
					Calificar producto
					<div className='f-img-container'>
						<Icon icon='icon-star white' size='1' tagtype='span' />
					</div>
				</button>
			) : null}
		</div>
	)

	const renderDrops = (drops, activeDrops) => {
		const nodeArray = []
		for (let index = 0; index < Number(drops); index++) {
			nodeArray.push(
				<svg key={index} width='24' height='35' viewBox='0 0 24 35'>
					<linearGradient id='grad1' x1='0%' y1='0%' x2='0%' y2='100%'>
						<stop
							offset='50%'
							stopOpacity={1}
							stopColor={props.dropsColor ? props.dropsColor : gothic}
						/>
						<stop offset='50%' stopOpacity={1} stopColor={lonchmara} />
					</linearGradient>
					<path
						className={
							index < Number(activeDrops)
								? activeDrops % 1 === 0.5 &&
								  parseInt(index + 0.5) === parseInt(activeDrops)
									? 'f-drop--active-medium'
									: 'f-drop f-drop--active'
								: 'f-drop'
						}
						d='M16.68,36.747A11.919,11.919,0,0,1,5,24.586C5,15.465,16.68,2,16.68,2S28.36,15.465,28.36,24.586A11.919,11.919,0,0,1,16.68,36.747Z'
						transform='translate(-5 -2)'
						fill={
							activeDrops % 1 === 0.5 &&
							parseInt(index + 0.5) === parseInt(activeDrops)
								? 'url(#grad1)'
								: 'none'
						}
					/>
				</svg>
			)
		}
		return nodeArray
	}

	/* Filter and sort detailRating elements */
	const setItemsDetailsRate = itemsDetailBack => {
		if (itemsDetailBack?.length < 1) {
			return false
		}

		const listCompare = [5, 4, 3, 2, 1]
		const newList = []
		listCompare.forEach(element => {
			const resultado = itemsDetailBack.find(i => i.qualification === element)
			newList.push(
				resultado !== undefined
					? resultado
					: { qualification: element, numberVotes: 0 }
			)
		})
		setItemsRateDetails(newList)
	}

	/* GetComments and load more comments */
	const handleGetComments = () => {
		setIsLoader(true)

		const payload = {
			idProduct: props.idProduct,
			limit,
			page: currentPage,
			countryId: country.codigoDelPais,
		}

		ProductService.getComments(payload)
			.then(res => {
				setComments(comments => comments.concat(res.data))
				setCurrentPage(page => page + 1)
				res.data.length < limit && setCommentPlus(false)
			})
			.catch(error => {
				console.log(
					'🚀 ~ file: comments-section-content.jsx ~ line 39 ~ ProductService.getComments ~ error',
					error
				)
			})
			.finally(() => setIsLoader(false))
	}

	/* Get comments */
	useEffect(() => {
		handleGetComments()
	}, [])

	/* Get qualify info */
	useEffect(() => {
		const payload = {
			idProduct: props.idProduct,
			countryId: country.codigoDelPais,
		}

		ProductService.getQualify(payload)
			.then(res => {
				setRatingDetail(res.data)
			})
			.catch(error => {
				console.log('Error consulta calificación', error)
			})

		ProductService.getQualifyDetail(payload)
			.then(res => {
				setItemsDetailsRate(res.data)
			})
			.catch(error => {
				console.log('Error consulta calificación', error)
			})
	}, [])

	const newSlug = props.slug

	const gtagEvent=()=>{
		const indexProductDetailSection = localStorage.getItem('indexProductDetail') || undefined
		localStorage.removeItem('indexProductDetail');
		if (!props.isFreeSamples) {
			const info = {
				event: 'view_item',
				params: {
					items: [{
						item_id: props.product.product?.codigoDeProducto,
						item_name: props.title,
						index: indexProductDetailSection,
						discount: 0,
						item_list_name: props.product.categoria[0]?.titulo || undefined,
						item_list_id: props.product.product?.id,
						affiliation: 'Tena Online',
						item_category: props.product.categoria[0]?.titulo || undefined,
						item_brand: 'Tena',
						item_variant: props.product.product?.linea[0].nombreDeEtiqueta || undefined,
						price: 0,
						currency: process.env.LOCALE,
						quantity: 0,
					}],
					value: 0,
					drip_degree: props.product.product?.tipoDeIncontinencia ? props.product.product?.tipoDeIncontinencia[0]?.nombreDeEtiqueta || '' : '',
					user_data: userInfo.user_data ? userInfo.user_data : '',
					log_status: userInfo.log_status,
					flow_type: 'Compra'
				}
			}
			return info
		}else {
			const info = {
				event: 'view_item',
				params: {
					items: [{
						item_id: props.product?.codigoDeProducto,
						item_name: props.title,
						index: indexProductDetailSection,
						discount: 0,
						item_list_name: props.product.categorias[0]?.titulo || undefined,
						item_list_id: props.product?.id,
						affiliation: 'Tena Online',
						item_category: props.product.categorias[0]?.titulo || undefined,
						item_brand: 'Tena',
						item_variant: props.product?.linea[0].nombreDeEtiqueta || undefined,
						price: 0,
						currency: process.env.LOCALE,
						quantity: 0,
					}],
					value: 0,
					drip_degree: props.product?.tipoDeIncontinencia ? props.product?.tipoDeIncontinencia[0]?.nombreDeEtiqueta || '' : '',
					user_data: userInfo.user_data ? userInfo.user_data : '',
					log_status: userInfo.log_status,
					flow_type: 'Muestra gratis'
				}
			}
			return info
		}
	}
	// agegar evento
	useEffect(() => {
	  pushGtagEvent(gtagEvent())
	}, [])
	

	const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-bannerppl-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-bannerppl-prev" onClick={onClick} />
  }

	const changeUrlVideo = urlVideo => {
    return urlVideo.includes("youtube")
      ? urlVideo.replace("watch?v=", "embed/")
      : urlVideo.includes("youtu.be")
      ? urlVideo.replace(".be/", "be.com/embed/")
      : urlVideo
  }

	const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 6000,
		nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

	return (
    <section className="f-product-detail-section">
      <div className="f-product-detail-section-primary">
        <label className={`f-${newSlug} f-mobile-title`}>{props.title}</label>
        <div className="image">
          {props.backButton}
          {props.imagenesProductoSlider ? (
            <Slider {...settings} className="f-slider">
              {props.imagenesProductoSlider.map((attr, key) => {
                return (
                  <Img
                    fluid={attr.fluid}
                    alt={attr && attr.description}
                    key={key}
                  />
                )
              })}
							{props.urlVideo && process.env.LOCALE === "es-CO" &&
								<div className="f-video-container">
									<iframe
										width="750"
										height="730"
										src={changeUrlVideo(props.urlVideo)}
										title="YouTube video player"
										frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
										allowfullscreen
									></iframe>
								</div>
							}
            </Slider>
          ) : props.isFreeSamples && props.imagenProducto !== null ? (
            <Img
              fluid={props.imagenProducto.fluid}
              alt={props.imagenProducto && props.imagenProducto.description}
            />
          ) : (
							<Slider {...settings} className="f-slider">
								<Img
									fluid={props.imagenProducto && props.imagenProducto.fluid}
									alt={props.imagenProducto && props.imagenProducto.description}
								/>
								{props.urlVideo && process.env.LOCALE === "es-CO" &&
									<div className="f-video-container">
										<iframe
											width="750"
											height="730"
											src={changeUrlVideo(props.urlVideo)}
											title="YouTube video player"
											frameborder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
											allowfullscreen
										></iframe>
								</div>
							}
							</Slider>
          )}

          {!props.isFreeSamples && !props.isMobile ? (
            <div className="f-likes-container">
              {isLiked(props.idProduct) ? (
                <div
                  className="f-icon-heart"
                  onClick={() => handleUnLike()}
                ></div>
              ) : (
                <div
                  className="f-icon-heart-gray"
                  onClick={() => handleLike()}
                ></div>
              )}
              <label className="f-count-likes">
                {formatNumber(
                  isFakeLiked
                    ? likeValue + 1
                    : isFakeUnLiked
                    ? likeValue - 1
                    : likeValue
                )}
              </label>
            </div>
          ) : null}
          {!props.isMobile && handleRenderButtons()}
        </div>
        {!props.isFreeSamples && props.isMobile ? (
          <div className="f-likes-container">
            {isLiked(props.idProduct) ? (
              <div
                className="f-icon-heart"
                onClick={() => handleUnLike()}
              ></div>
            ) : (
              <div
                className="f-icon-heart-gray"
                onClick={() => handleLike()}
              ></div>
            )}
            <label className="f-count-likes">
              {formatNumber(
                isFakeLiked
                  ? likeValue + 1
                  : isFakeUnLiked
                  ? likeValue - 1
                  : likeValue
              )}
            </label>
          </div>
        ) : null}
        <div className="description">
          {props.isMobile && handleRenderButtons()}
          <h1 className={`f-${newSlug} f-card-product-title f-h1`}>
            {props.title}
          </h1>
          {props.descripcion &&
            documentToReactComponents(props.descripcion.json, options)}
          {props.nameButton && (
            <a className="f-button_free_sample" href="#go-section-user">
              {convertText(props.nameButton)}
            </a>
          )}
          <div className="f-card-product-resena f-p" id="go-section-user">
            {props.nivelIncontinencia &&
              documentToReactComponents(props.nivelIncontinencia.json)}
            <div>
              {props.numeroGotas &&
                renderDrops(props.numeroGotas, props.numeroGotasLlenas)}
            </div>
          </div>
          {props.atributes && (
            <div className="f-card-product-atributes">
              {props.atributes.map((attr, key) => (
                <div className="f-atribute" key={key}>
                  <img
                    src={attr.imagenDelSello.file.url}
                    alt={attr.imagenDelSello.description}
                  />
                  <p>
                    {documentToReactComponents(attr.descripcionDelSello.json)}
                  </p>
                </div>
              ))}
            </div>
          )}
          {props.sizes && (
            <div className="f-card-product-sizes">
              <h4 className="f-title">{props.lbtalla}</h4>
              <div className="f-sizes">
                {props.sizes.map((size, key) => {
                  const isSizeSelected =
                    props.samples.find(sample => sample.size === size) ||
                    (props.samplesSent &&
                      props.samplesSent.find(
                        s => s.size === size && s.id === props.codigoDeProducto
                      ))
                  return (
                    <div
                      className={`f-sizes-size ${
                        size === props.sizeSelected
                          ? `f-sizes-size-select ${size.toLowerCase()}`
                          : isSizeSelected
                          ? "f-sizes-size-selected"
                          : ""
                      }`}
                      onClick={() => !isSizeSelected && props.selectSize(size)}
                      key={key}
                    >
                      {size}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {!props.isFreeSamples ? (
        <>
          <hr className="f-custom-hr" />
          {ratingDetail &&
            (ratingDetail?.productAvg !== 0 ||
              ratingDetail?.totalQualifications !== 0) &&
            itemsRateDetails && (
              <QualifySectionContent
                isMobile={props.isMobile}
                ratingDetail={ratingDetail}
                itemsRateDetails={itemsRateDetails}
              />
            )}
          {comments && comments.length > 0 && (
            <CommentsSectionContent
              isMobile={props.isMobile}
              comments={comments}
              currentPage={currentPage}
              isLoader={isLoader}
              commentPlus={commentPlus}
              limit={limit}
              handleGetComments={handleGetComments}
            />
          )}
        </>
      ) : null}
      {props.beneficios}
      {props.products}
    </section>
  )
}

export default ProductDetailSection
